import { render, staticRenderFns } from "./ProjectCorp.vue?vue&type=template&id=6f97ae1e&scoped=true&"
import script from "./ProjectCorp.vue?vue&type=script&lang=ts&"
export * from "./ProjectCorp.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCorp.vue?vue&type=style&index=0&id=6f97ae1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97ae1e",
  null
  
)

export default component.exports